import { render, staticRenderFns } from "./EpList.vue?vue&type=template&id=bba81c66"
import script from "./EpList.vue?vue&type=script&lang=js"
export * from "./EpList.vue?vue&type=script&lang=js"
import style0 from "./EpList.vue?vue&type=style&index=0&id=bba81c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports